import Relay from 'react-relay/classic';

export default class ResetPinSessionRoute extends Relay.Route {
  static routeName = 'ResetPinSessionRoute';
  static queries = {
    resetPinSession: (Component) => Relay.QL`
      query {
        resetPinSession {
          ${Component.getFragment('resetPinSession')},
        },
      }`,
  };
}



// WEBPACK FOOTER //
// ./js/routes/ResetPinSessionRoute.js